"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-datepicker/~/date-fns/_lib/defaultOptions/index.js
// module id = 101
// module chunks = 0